import React from "react";
import { View } from "react-native";
import {
  Icon,
  Panel,
  theme,
  Text,
  IconProps,
  TextProps,
} from "@clearabee/ui-library-native";
import {
  ColorKeyVariants,
  getColorFromVariantKey,
} from "@clearabee/ui-library-base";

export interface IconPanelProps {
  subtitle: string;
  children?: React.ReactNode;
  icon: keyof typeof Icon;
  iconColor: IconProps["color"];
  backgroundColor: ColorKeyVariants<keyof typeof theme.colors>;
  subtitleColor?: TextProps["color"];
}

/**
 * Possibly move to UI Library?
 * https://clearabee.atlassian.net/browse/HWA-646
 */
export const IconPanel = ({
  icon,
  iconColor,
  backgroundColor,
  children,
  subtitle,
  subtitleColor = "light",
}: IconPanelProps): React.ReactElement => {
  const color = backgroundColor
    ? getColorFromVariantKey(backgroundColor)
    : undefined;
  const BackgroundIcon = Icon[icon];

  return (
    <Panel
      styles={{
        backgroundColor: color,
        marginTop: theme.spacing.small,
        paddingTop: theme.spacing.small,
      }}
      shadow={false}
    >
      <View
        style={{
          position: "absolute",
          right: 10,
          bottom: -40,
        }}
      >
        {typeof BackgroundIcon === "function" && (
          <BackgroundIcon
            color={iconColor}
            opacity={0.5}
            height={180}
            width={180}
            style={{
              transform: [{ rotate: "-45deg" }],
            }}
          />
        )}
      </View>
      <Text
        color={subtitleColor}
        fontSize="xsmall2"
        styles={{
          fontFamily: "ProximaSemiBold",
        }}
      >
        {subtitle}
      </Text>
      {children}
    </Panel>
  );
};
